import StudentWithAvatar from '../../../students/StudentWithAvatar'
import SeriesEnrollmentStatusSelect from './SeriesEnrollmentStatusSelect'
import { ReactComponent as MenuIcon } from '../../../../assets/images/common/icons/more-icon-vertical.svg'
import { ReactComponent as MessageIcon } from '../../../../assets/images/common/icons/Message.svg'
import { calculateAge, genderLabel } from '../../../../utility/userHelper'
import colors from '../../../../assets/styles/globals.scss'
import classes from './EventRoster.module.scss'
import PropTypes from 'prop-types'

const StudentRow = ({ status, std, handleStudentMenuClick }) => (
  <tr
    className={'students-table-row'}
  >
    <td style={{ width: '25%' }} className='golfer-data'>
      <StudentWithAvatar student={std} withName />
    </td>
    <td style={{ width: '19%' }} className='px-5'>{calculateAge(std.birthdate)} yrs, {genderLabel[std.gender]}</td>
    <td style={{ width: '17%' }}>{std.courseName || 'Manually Added'}</td>
    <td style={{ width: '13%' }}><SeriesEnrollmentStatusSelect isDisabled={status === 'completed'} enrollment={std}/></td>
    <td style={{ width: '8%' }}>
      {
        std.pairingGroupId ?
          <span className={classes.paired}>Paired</span> :
          <span className={classes.notPaired}>Not Paired</span>
      }
    </td>
    <td className='centered-text'>{std.note &&
      <MessageIcon data-tip={std.note} data-tip-disable={false} className={classes.messageIcon}/>}
    </td>
    <td style={{ width: '10%' }} className='centered-text'>{std.stats && std.stats[std.level].recordScore || '-'}</td>
    <td style={{ width: '10%' }} className='centered-text'>{std.stats && std.stats[std.level].levelAttempts || '-'}</td>
    <td className='centered-text'>
      <div className={classes.deleteButton} onClick={() => handleStudentMenuClick(std)} aria-hidden='true' id='studentMenuButton'>
        <MenuIcon fill={colors.primaryNavy} hidden={status === 'completed'}/>
      </div>
    </td>
  </tr>
)

StudentRow.propTypes = {
  status: PropTypes.string,
  std: PropTypes.shape({
    id: PropTypes.number,
    gender: PropTypes.number,
    courseName: PropTypes.string,
    birthdate: PropTypes.string,
    pairingGroupId: PropTypes.number,
    note: PropTypes.string,
    stats: PropTypes.object,
    level: PropTypes.number,
  }),
  handleStudentMenuClick: PropTypes.func,
}

export default StudentRow
